module.exports = __webpack_public_path__ + "img/GP 2 - Hungary_StartITup_ABC workshops.688bbbf9.jpg";